import axios from "axios";

const BACKEND_URL = "https://dv2.culsight.com";
const API = `${BACKEND_URL}/api`;

export const LOGIN = (email, password) => {
  return axios.post(`${API}/auth/login`, {
    email,
    password,
  });
};